import React, { useState } from "react";
import {
  patchRequest,
} from "../../../../../utils/httpRequest";
import "../../../styles/trademodals.scss";
import { t } from "../../../../../utils/i18n";

const NoticeMessageModal = ({ onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [isDontShowChecked, setIsDontShowChecked] = useState(false); // Track "Don't show me again" checkbox
  const [showCheckboxWarning, setShowCheckboxWarning] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsCheckboxChecked(event.target.checked);
    setShowCheckboxWarning(false); // Remove the warning if the checkbox is checked
  };

  const updateScamAlert = () => {
    const baseURL = `${window.location.protocol}//${window.location.host}`;
  
    const data = {
      scam_alert: "closed",
    };
  
    patchRequest(`${baseURL}/api/v1/scam_alert`, data)
      .then((response) => {
        if (!response.message) {
          console.error("Unexpected response format", response);
        }
      })
      .catch((error) => {
        console.error("Error updating scam alert:", error);
      });
  };  

  const handleDontShowChange = (event) => {
    setIsDontShowChecked(event.target.checked);
  };

  const handleCloseClick = () => {
    if (isDontShowChecked) {
      updateScamAlert();
    }
    onClose("noticeMessageModal");
  };

  const handleConfirmClick = () => {
    if (!isCheckboxChecked) {
      setShowCheckboxWarning(true); // Show the warning if the checkbox is not checked
      return;
    }
    if (isDontShowChecked) {
      updateScamAlert();
    }
    onClose("noticeMessageModal");
  };

  return (
    <div
      className="modal-status-cont"
      tabIndex={-1}
      aria-hidden="true"
      id="noticeMessageModal"
      aria-labelledby="disputeConfirmModalLabel"
    >
      <div className="modal-status-alert-cont">
        <div>
          <button
            type="button"
            className="close"
            onClick={handleCloseClick}
            aria-label={t("p2p.common.close")}
            disabled={isLoading}
          >
            <span aria-hidden="true">{" "}</span>
          </button>
          <br />
        </div>
        <div>
          <div className="modal-title" id="disputeConfirmModalLabel">
            <p style={{ textAlign: "center" }}>
              <i className="fas fa-exclamation-triangle" aria-hidden="true"></i>
              {" "}
              {t("p2p.notice.title")}
            </p>
          </div>
          <div className="trademodal-notice">
            <span dangerouslySetInnerHTML={{ __html: t("p2p.notice.body_html") }} />
          </div>
          <br />
          <div className="trademodal-form-check">
            <input
              className={`trademodal-form-check-input ${
                showCheckboxWarning ? "checkbox-warning" : ""
              }`}
              type="checkbox"
              id="noticeMessageCheckbox"
              onChange={handleCheckboxChange}
            />
            <label
              className="trademodal-form-check-label"
              htmlFor="noticeMessageCheckbox"
            >
              <strong> {t("p2p.notice.agree")}</strong>
            <br/>
            </label>
          </div>
          {showCheckboxWarning && (
            <p className="checkbox-warning-text">{t("p2p.notice.check_box")}</p>
          )}
          <div className="trademodal-form-check mt-1">
            <input
              className="trademodal-form-check-input"
              type="checkbox"
              id="dontShowAgainCheckbox"
              onChange={handleDontShowChange}
            />
            <label
              className="trademodal-form-check-label"
              htmlFor="dontShowAgainCheckbox"
            >
              <strong> {t("p2p.notice.dont_show")}</strong>
            </label>
          </div>
          {/* Buttons */}
          <div className="modal-buttons-section">
            <div>
              <button
                type="button"
                className="modal-tradeaction-paidbtn"
                onClick={handleConfirmClick}
              >
                {t("p2p.notice.confirm")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoticeMessageModal;
